<template>
  <div class="form-check form-switch form-check-custom form-check-solid" :class="this.class">
    <label v-if="placeholderSecondary" class="form-check-label me-2" :for="id" v-html="this.placeholderSecondary"></label>
    <input
        :disabled="disabled"
        :checked="Boolean(modelValue)"
        :value="Boolean(modelValue)"
        :class="size"
        :name="name"
        :id="id"
        class="form-check-input"
        type="checkbox"
        @input="this.$emit('update:modelValue', Boolean(!modelValue))"
    />
    <label class="form-check-label" :for="id" v-html="this.placeholder"></label>
  </div>
</template>

<script>
export default {
  name: 'SwitchBoxField',
  props: {
    placeholder: {
      type: String,
      default: ''
    },
    placeholderSecondary: {
      type: String,
      default: ''
    },
    modelValue: {
      type: [String, Number, Boolean],
      default: false
    },
    disabled: {
      type: Boolean,
      default: false
    },
    class: {
      type: [String, Array, Object],
      default: ''
    },
    name: {
      type: String,
      default: ''
    },
    size: {
      type: [String, Number],
      default: 1
    },
    id: {
      type: [String, Number],
      default: null
    }
  }
}
</script>

<style scoped>

</style>